import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
//#region types
import { TranslationKeys } from "translations";
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
import { BusinessUnitFormTypes } from "models/formTypes";
import { FormFieldConstants } from "utils/constants";
//#endregion
//#region components
import {
  DashboardButtonGroup,
  FilterButton,
  PageLayouts,
  ReportSearchInput,
  SearchContextProvider,
  StyledButton,
} from "components/common";
import { Grid } from "@mui/material";
import BusinessUnitsList from "./businessUnitsList";
import useBusinessUnitReportFilterDefinition from "./forms/useBusinessUnitReportFilterDefinition";
import { useBusinessUnitService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance, UrlHelper, DateHelper } from "utils/helpers";

const BusinessUnitReport: React.FC = (props) => {
  const businessUnitService = useBusinessUnitService();
  const location = useLocation();
  const navigate = useNavigate();

  const onBusinessUnitsCreateClick = () => {
    navigate(UrlHelper.formatPath(`/BusinessUnits/Create`), {
      state: { background: location, preserveSearch: true },
    });
  };

  const { filterFormFields: reportFilterDefinition, filterQueryStateHandler } = useBusinessUnitReportFilterDefinition();

  const getTopRightButtons = () => {
    let buttons: (React.ReactElement | typeof ACTION_SEPARATOR)[] = [
      <ReportSearchInput
        placeholder={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.BusinessUnit.SearchBusinessUnit)}
        key={FormFieldConstants.BusinessUnit.Filter.BusinessUnitName}
      />,
      ACTION_SEPARATOR,
    ];

    if (businessUnitService.hasCreatePermissions()) {
      buttons = [
        ...buttons,
        <StyledButton size="sm" onClick={onBusinessUnitsCreateClick}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.BusinessUnit.CreateBusinessUnit)}
        </StyledButton>,
        ACTION_SEPARATOR,
      ];
    }
    buttons = [...buttons, <FilterButton />];

    return buttons;
  };

  return (
    <SearchContextProvider>
      <PageLayouts.DashboardLayout<BusinessUnitFormTypes.Filter>
        entityKey={0}
        hasPermissions={businessUnitService.isBusinessUnitsAvailable()}
        title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.BusinessUnit.BusinessUnits)}
        filterFields={reportFilterDefinition}
        filterQueryStateHandler={filterQueryStateHandler}
        initialFilter={{
          period: DateHelper.getFirstDayOfPreviousMonth(new Date()),
        }}
        topRightButtons={<DashboardButtonGroup buttons={getTopRightButtons()} />}
      >
        <Grid container item>
          <BusinessUnitsList />
        </Grid>
      </PageLayouts.DashboardLayout>
    </SearchContextProvider>
  );
};

export default BusinessUnitReport;
